import React, { FunctionComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import classNames from '../../../utils/classnames';

export interface ButtonProps {
    variant?: 'tertiary' | 'ghost' | 'secondary' | 'link';
    isLoading?: boolean;
    type?: 'button' | 'submit';
    extraClasses?: string;
    url?: string;
    label?: string;
    disabled?: boolean;
    onClick?: (e?: any) => void;
}

export const Button: FunctionComponent<ButtonProps> = ({
    variant = '',
    type = 'submit',
    url = null,
    label,
    extraClasses,
    disabled = false,
    isLoading,
    onClick = () => {},
    ...rest
}) => {
    const classes = classNames(
        {
            'c-button': !variant,
            'c-button--tertiary': variant === 'tertiary',
            'c-button--secondary': variant === 'secondary',
            'c-button--ghost': variant === 'ghost',
            'c-button--link': variant === 'link',
            'button--disabled': disabled,
            'button--is-loading': isLoading,
        },
        extraClasses,
    );

    return (
        <Fragment>
            {!url && (
                <button type={type} className={classes} {...rest} onClick={onClick} disabled={disabled}>
                    {label && <span className="button__label">{label}</span>}
                </button>
            )}
            {url && (
                <Link to={url} className={classes} {...rest} onClick={onClick}>
                    {label && <span className="button__label">{label}</span>}
                </Link>
            )}
        </Fragment>
    );
};
